module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU4Ny42IDcyOC45bC0xOTQuMy0xOTQuMmEzMiAzMiAwIDAgMSAwLTQ1LjNsMTk0LjMtMTk0LjNhMzIgMzIgMCAwIDEgNTQuNiAyMi42VjcwNi4yYTMyIDMyIDAgMCAxLTU0LjYgMjIuNnoiIGZpbGw9IiMwIiBwLWlkPSIzMzI2Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret left-filled.svg
// module id = /ssl
// module chunks = 75